import { ShipmentInfo } from 'api';
import { useTranslation } from 'i18n';
import React, { ChangeEvent } from 'react';
import { Box, FilePicker, Link, SectionContainer } from 'ui';

type BookingConfirmationDocProps = {
  shipmentData?: ShipmentInfo;
  handleFileChange: (event: ChangeEvent<HTMLInputElement>) => void;
};

export const BookingConfirmationDoc = ({ shipmentData, handleFileChange }: BookingConfirmationDocProps) => {
  const { t } = useTranslation('orders');
  const bookingConfirmation = shipmentData?.booking_confirmation;

  return (
    <SectionContainer columns={1} title={t('bookingConfirmationDoc.title')}>
      {bookingConfirmation?.file_url ? (
        <Box
          sx={{
            my: 1,
          }}
        >
          {t('bookingConfirmationDoc.labels.currently')}{' '}
          <Link href={bookingConfirmation.file_url} sx={{ fontWeight: 'bold' }}>
            {bookingConfirmation.alias || bookingConfirmation.file_name}
          </Link>
        </Box>
      ) : null}
      <Box
        sx={{
          mt: 1,
          mb: 2,
        }}
      >
        <FilePicker
          accept="*"
          onChange={handleFileChange}
          label={t('bookingConfirmationDoc.labels.uploadDocument')}
          showSelectedFileName
        />
      </Box>
    </SectionContainer>
  );
};
